import { useFeatureFlags } from 'feature-flags';

export const useVideoDownloadPermission = () => {
  const { redact_pii_video_download } = useFeatureFlags(['redact_pii_video_download']);

  return {
    isDisableVideoDownload: !!redact_pii_video_download,
  };
};
